/**
 * Mock email analytics graphs
 *
 */
export interface EmailMockGraphSection {
  readonly title: string;
  readonly fileName: string;
  readonly contentId: string;
}

export const MOCK_EMAIL_GRAPH_ASSET_DIR = 'assets/analytics-graphs' as const;

export function mockEmailGraphAssetPath(section: EmailMockGraphSection): string {
  return `${MOCK_EMAIL_GRAPH_ASSET_DIR}/${section.fileName}`;
}

export const MOCK_EMAIL_GRAPH_SECTIONS: readonly EmailMockGraphSection[] = [
  {
    title: 'Medication/Audit Analytics Graph',
    fileName: 'medication-audit-analytics-graph.png',
    contentId: 'mock-graph-medication-audit-analytics',
  },
  {
    title: 'Med Removal - Risk Scores Graph',
    fileName: 'med-removal-risk-scores-graph.png',
    contentId: 'mock-graph-med-removal-risk-scores',
  },
  {
    title: 'Waste Transactions - Risk Scores Graph',
    fileName: 'waste-transactions-risk-scores-graph.png',
    contentId: 'mock-graph-waste-transactions-risk-scores',
  },
  {
    title: 'Charted - Risk Scores Graph',
    fileName: 'charted-risk-scores-graph.png',
    contentId: 'mock-graph-charted-risk-scores',
  },
  {
    title: 'Unaccounted Variances - Risk Scores Graph',
    fileName: 'unaccounted-variances-risk-scores-graph.png',
    contentId: 'mock-graph-unaccounted-variances-risk-scores',
  },
] as const;
